module.exports = __webpack_public_path__ + "img/标题icon_6.7e9ddab4.png";